import React from "react";
import arrow from "../assets/images/svg/card-arrow.svg";
import ReactPlayer from "react-player";
const Card = () => {
  return (
    <>
      <section className="cards_section">
        <div
          id="react-player-card-video"
          className="position-relative z_index_0 overflow-hidden bg_cards"
        >
          <ReactPlayer
            className="react-player"
            url="https://vz-e28eac45-f0a.b-cdn.net/da9f470a-b9f2-4d8f-8034-95640c81349d/playlist.m3u8"
            width="100%"
            playing={true}
            loop={true}
            muted={true}
            height="100%"
          />
          <div className="  position-absolute z_index_99 positioning_content_card">
            <div className=" container ">
              <div className="row justify-content-center justify-content-lg-between ">
                <div className="col-md-10 col-lg-5">
                  <h2
                    className="font-xl fw-normal color-white ff_josfin card_heading text-center text-lg-start mb-4 mb-md-5 mb-lg-0"
                    data-aos="fade-right"
                  >
                    KEY BENEFITS OF NEXT-GEN INDUSTRIAL CYBERSECURITY SOLUTIONS
                  </h2>
                </div>
                <div className="col-lg-7 col-xxl-6 pe-xxl-5">
                  <div className="d-flex flex_warp justify-content-center justify-content-lg-between gap-3 gap-xl-4">
                    <div className="col-sm-4 mt-md-5 pt-lg-5">
                      <div
                        className="Benefits_cards position-relative mb-3 mb-xl-4"
                        data-aos="zoom-in"
                        data-aos-delay="100"
                      >
                        <h4 className="font-2xl  cards-number mb-2 ">03</h4>
                        <p className="cards_pg  color-light-black fw_500 ff_josfin mb-0 text-uppercase">
                          Secure Field Operations
                        </p>
                        <a href="#">
                          <img
                            className="position-absolute card_arrow"
                            src={arrow}
                            alt="arrow"
                          />
                        </a>
                      </div>
                      <div
                        className="Benefits_cards position-relative"
                        data-aos="zoom-in"
                        data-aos-delay="200"
                      >
                        <h4 className="font-2xl  cards-number mb-2">06</h4>
                        <p className="cards_pg color-light-black fw_500 ff_josfin mb-0 text-uppercase">
                          Dedicated Incident Response Team
                        </p>
                        <a href="#">
                          <img
                            className="position-absolute card_arrow"
                            src={arrow}
                            alt="arrow"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div
                        className="Benefits_cards position-relative mb-3 mb-xl-4"
                        data-aos="zoom-in"
                        data-aos-delay="300"
                      >
                        <h4 className="font-2xl  cards-number mb-2">01</h4>
                        <p className="cards_pg  color-light-black fw_500 ff_josfin mb-0 text-uppercase">
                          Seamless Integration
                        </p>
                        <a href="#">
                          <img
                            className="position-absolute card_arrow"
                            src={arrow}
                            alt="arrow"
                          />
                        </a>
                      </div>
                      <div
                        className="Benefits_cards position-relative"
                        data-aos="zoom-in"
                        data-aos-delay="400"
                      >
                        <h4 className="font-2xl  cards-number mb-2">04</h4>
                        <p className="cards_pg  color-light-black fw_500 ff_josfin mb-0 text-uppercase">
                          Dedicated Data Centers
                        </p>
                        <a href="#">
                          <img
                            className="position-absolute card_arrow"
                            src={arrow}
                            alt="arrow"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="col-md-4 mt-md-5">
                      <div className="d-flex gap-3 flex-md-column ">
                        <div
                          className="Benefits_cards position-relative mb-xxl-2"
                          data-aos="zoom-in"
                          data-aos-delay="500"
                        >
                          <h4 className="font-2xl cards-number mb-2">02</h4>
                          <p className="cards_pg color-light-black fw_500 ff_josfin mb-0 text-uppercase">
                            Sector Specific SOC
                          </p>
                          <a href="#">
                            <img
                              className="position-absolute card_arrow"
                              src={arrow}
                              alt="arrow"
                            />
                          </a>
                        </div>
                        <div
                          className="Benefits_cards position-relative"
                          data-aos="zoom-in"
                          data-aos-delay="700"
                        >
                          <h4 className="font-2xl  cards-number mb-2">05</h4>
                          <p className="cards_pg  color-light-black fw_500 ff_josfin mb-0">
                            Industrial Regulations Compliance
                          </p>
                          <a href="#">
                            <img
                              className="position-absolute card_arrow"
                              src={arrow}
                              alt="arrow"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Card;
